import { getOptionalTrackers } from '../../utils/getOptionalTrackers'

/**
 * Delete local and session storage items
 */
export function cleanBrowserStorage() {
  const localStorageItemsToDelete = getOptionalTrackers(window.localStorage)
  const sessionStorageItemsToDelete = getOptionalTrackers(window.sessionStorage)

  localStorageItemsToDelete.forEach((localStorageItemName) => {
    window.localStorage.removeItem(localStorageItemName)
  })

  sessionStorageItemsToDelete.forEach((sessionStorageItemName) => {
    window.sessionStorage.removeItem(sessionStorageItemName)
  })
}
